module.exports = __webpack_public_path__ + "static/media/theme-traditional-card.1439555e.svg";